module.exports = __webpack_public_path__ + "media/wyposazenie/kolor-8881feab.png";